import React from 'react';
import { useHistory } from 'react-router-dom';

import APModal from 'components/Modal/APModal';

/**
 * @typedef {Object} WeddingsLimit
 * @property {number} limit - Maximum number of weddings allowed
 * @property {boolean} isExceeded - Whether the wedding limit has been exceeded
 * @property {boolean} isOwner - Whether the current user is the owner
 * @property {number} activeWeddingCount - Current count of active weddings
 */

/**
 * Modal component that displays project limit information and status
 * @param {Object} props - Component props
 * @param {WeddingsLimit} props.projectsLimit - Object containing project limit data and status
 * @param {function(boolean): null} props.setIsOpen - Callback function to control modal open/closed state
 * @returns {JSX.Element} The projects limit modal component
 */
const ProjectsLimitModal = ({ projectsLimit, setIsOpen }) => {
  const history = useHistory();

  const projectsLimitErrorOnClose = () => {
    if (projectsLimit?.isOwner) {
      history.push('/app/v2/account/billing');
    } else {
      setIsOpen(false);
    }
  };

  const projectsLimitErrorAction = () => {
    return (
      <button
        className="button"
        onClick={projectsLimitErrorOnClose}
      >
        {projectsLimit?.isOwner ? 'Upgrade subscription' : 'Got it'}
      </button>
    );
  };

  const projectsLimitErrorContent = () => {
    if (projectsLimit?.isOwner) {
      return (
        `You're on a roll—but you're at your ${projectsLimit.limit}-project limit! To keep the momentum
        going and create more projects, upgrade your plan for increased capacity.`
      );
    }
    return (
      `You’ve hit the project limit for your current plan. To keep things moving,
      reach out to your account owner and request an upgrade to unlock more project space!`
    );
  };

  return (
    <APModal
      open
      onClose={() => setIsOpen(false)}
      name="projects-limit-error"
      title="Heads up!"
      actions={projectsLimitErrorAction()}
    >
      <div className="content-container content-container--narrow">
        <div>{projectsLimitErrorContent()}</div>
      </div>
    </APModal>
  );
};

export default ProjectsLimitModal;
